import { RouterState } from 'connected-react-router';
import { AnyAction, Dispatch } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { StackState } from './stack/types';
import { stackReducer } from './stack/reducers';
import { UserState } from './user/types';
import { userReducer } from './user/reducers';
import { AuthState } from './auth/types';
import { authReducer } from './auth/reducers';
import { NotificationState } from './notification/types';
import { notificationReducer } from './notification/reducers';
import { DeviceState } from './device/types';
import { deviceReducer } from './device/reducers';

export interface ApplicationState {
  router: RouterState;
  notification: NotificationState;
  device: DeviceState;
  auth: AuthState;
  user: UserState;
  stacks: StackState;
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
  notification: notificationReducer,
  device: deviceReducer,
  auth: authReducer,
  stacks: stackReducer,
  user: userReducer,
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
  (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}

export type AppDispatch = ThunkDispatch<ApplicationState, unknown, AnyAction> &
  Dispatch<AnyAction>;
